import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function OrdinalsBlock9({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" id={"9"} d="M5.3869 0C6.09723 0 6.76864 0.180952 7.40113 0.542857C8.02389 0.904762 8.52015 1.39048 8.88991 2C9.25967 2.61905 9.44455 3.28571 9.44455 4V6H2.59909V5.98571C2.03471 5.98571 1.55305 5.79048 1.1541 5.4C0.755141 5.00952 0.555664 4.54286 0.555664 4H7.41573C7.41573 3.46667 7.22111 2.98571 6.83189 2.55714C6.41348 2.18571 5.92695 2 5.3723 2H4.64251V1.98571H2.62828H2.59909H0.555664L2.59909 0H2.62828H5.3869ZM7.40113 8V10H2.58449C2.02985 10 1.55305 9.80476 1.1541 9.41429C0.755141 9.02381 0.555664 8.55238 0.555664 8H7.40113ZM2.59909 4V1.98571H0.555664V4H2.59909ZM9.44455 8V6H7.40113V10L9.44455 8Z" fill="currentColor" /></Svg>;
}
export default OrdinalsBlock9;